module.exports = __webpack_public_path__ + "static/media/Coupe.fbf36f89.svg";